import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Session } from '../../../../models/session.school.model';
import { MomentPipe } from '../../../../pipes/moment.pipe';
import { AppState } from '../../../../state/appstate';
import * as sessionSelector from '../../../../state/selectors/session.school.selector';
import { BtnBackComponent } from '../../../components/buttons/btn-back/btn-back.component';

@Component({
  selector: 'app-detail-session',
  standalone: true,
  imports: [BtnBackComponent, AsyncPipe, MomentPipe],
  templateUrl: './detail-session.component.html',
  styleUrl: './detail-session.component.css',
})
export class DetailSessionComponent implements OnInit {
  store: Store<AppState> = inject(Store);
  route: ActivatedRoute = inject(ActivatedRoute);

  session$: Observable<Session | null | undefined> = new Observable();

  groupId: string | null = this.route.snapshot.paramMap.get('groupId');
  gradeId: string | null = this.route.snapshot.paramMap.get('gradeId');
  sessionId: string | null = this.route.snapshot.paramMap.get('sessionId');

  constructor() {
    this.route.paramMap.subscribe((params) => {
      this.groupId = params.get('groupId');
      this.gradeId = params.get('gradeId');
      this.sessionId = params.get('sessionId');

      if (this.sessionId) {
        this.session$ = this.store.select(
          sessionSelector.getSessionById(this.sessionId)
        );
      }
    });
  }

  ngOnInit(): void {}
}
